import { useAgenciesStore } from '@ezio/features/agencies/store'
import { useAlertsStore } from '@ezio/features/alerts/store'
import { useAuthStore } from '@ezio/features/auth/store'
import { useBankStore } from '@ezio/features/bank/store'
import { useCardsStore } from '@ezio/features/cards/store'
import { useUsersStore } from '@ezio/features/users/store'
import { useNetworksStore } from '@ezio/features/networks/store'
import { useOrganizationsStore } from '@ezio/features/organizations/store'
import { usePayoutsStore } from '@ezio/features/payouts/store'
import { usePayinsStore } from '@ezio/features/payins/store'
import { useTransactionsStore } from '@ezio/features/transactions/store'

const init = async () => {}

const reset = () => {
    useAgenciesStore().reset()
    useAlertsStore().reset()
    useAuthStore().reset()
    useBankStore().reset()
    useUsersStore().reset()
    useNetworksStore().reset()
    useOrganizationsStore().reset()
    usePayoutsStore().reset()
    usePayinsStore().reset()
    useTransactionsStore().reset()
}

export { init, useAgenciesStore, useAlertsStore, useAuthStore, useBankStore, useCardsStore, useUsersStore, useNetworksStore, useOrganizationsStore, usePayoutsStore, usePayinsStore, useTransactionsStore, reset }
